<div class="student-programs">
  <div class="k-d-flex k-justify-content-between title" *ngIf="!isDashboardIep">
    <h4 class="subsection__heading k-p-4 !k-mt-0 ">
      {{title}} ({{programs?.length || 0}})
    </h4>
  </div>

  <div class="programs-grid" *ngIf="programs?.length">

    <div class="program-card" *ngFor="let program of programs; let i = index">
      <kendo-card class="!k-w-full !k-p-0">

        <!-- CARD HEADER -->
        <kendo-card-header>
          <div class="k-d-flex k-justify-content-between k-pb-6">
            <div>
              <span *ngIf="showFinalizedDate">
                IEP Finalized:
                <span [attr.aria-label]="studentIEP?.iepFinalisedDate ? (studentIEP?.iepFinalisedDate | date : 'MMMM d, y') : ''">
                  <span aria-hidden="true">{{studentIEP?.iepFinalisedDate | formatDate}}</span>
                </span>
              </span>
              <h5 class="subsection__subheading !k-m-0">
                {{ program?.mandateDescription }}
              </h5>
            </div>

            <div class="k-d-flex k-gap-2 k-align-items-end k-h-7">
              <div *ngIf="program?.isCompensatory" class="small-text-semibold comp-chip">
                Comp
              </div>
              <div *ngIf="program?.isTwelveMonth" class="small-text-semibold months-chip">
                12 months
              </div>
              <div class="menu-wrapper">
                <ng-container *ngIf="allowCaptureFAD(program)">
                  <button #menuAnchor class="icon-color" kendoButton (click)="selectProgram(program)"
                    aria-label="More options" fillMode="flat" size="none">
                    <fa-icon icon="ellipsis-vertical" size="1x"></fa-icon>
                  </button>
                  <kendo-contextmenu [target]="menuAnchor" [items]="actions" showOn="click" (select)="displayFAD()">
                    <ng-template kendoMenuItemTemplate let-item="item">
                      {{ item }}
                    </ng-template>
                  </kendo-contextmenu>
                </ng-container>
              </div>
            </div>
          </div>
          <kendo-stacklayout orientation="horizontal"
            class="body-text k-flex-wrap k-justify-content-start program-meta">
            <div class="k-hstack" *ngIf="program?.language">
              <span [ngClass]="{ 'label-border': program?.frequency || program?.duration}">
                {{program?.language}}
              </span>
            </div>
            <div class="k-hstack" *ngIf="program?.frequency">
              <span [ngClass]="{ 'label-border': program?.duration || program?.ratio  }">
                {{program?.frequency}}
              </span>
            </div>
            <div class="k-hstack" *ngIf="program?.duration">
              <span [ngClass]="{ 'label-border':  program?.ratio  }">
                {{program?.duration['description'] ??
                program?.duration}}</span>
            </div>
            <div class="k-hstack" *ngIf="program?.ratio">
              <span [ngClass]="{ 'label-border': program?.groupType}"><span *ngIf="program?.ratio">
                  | Student
                  to Teacher Ratio:</span> {{program?.ratio}} </span>
            </div>
            <div class="k-hstack"
              *ngIf="program?.serviceType && program?.mandateDescription !== 'Special Education Teacher Support Services'">
              <span class="margin"><span *ngIf="program?.serviceType">| </span> Service Type: {{program?.serviceType}}
              </span>
            </div>
            <div class="k-hstack" *ngIf="program?.groupType">
              <span class="margin"><span *ngIf="program?.groupType">| </span> Group Type: {{program?.groupType}} </span>
            </div>
            <div class="k-hstack" *ngIf="shouldShowGroupSize(program)">
              <span class="margin"><span *ngIf="program?.groupSize">| </span>Group Size: {{program?.groupSize}} </span>
            </div>

          </kendo-stacklayout>
        </kendo-card-header>

        <kendo-card-body class="body-text k-px-6">
          <div class="k-d-flex k-align-items-start k-gap-2">
            <fa-icon icon="calendar"></fa-icon>
            <div class="k-d-flex k-flex-col">
              <span>
                Service Dates:
                <span [attr.aria-label]="program?.serviceStartDate ? (program?.serviceStartDate | date : 'MMMM d, y') : ''">
                  <span aria-hidden="true">{{ program?.serviceStartDate | formatDate }}</span>
                </span>
                -
                <span [attr.aria-label]="program?.serviceEndDate ? (program?.serviceEndDate | date : 'MMMM d, y') : ''">
                  <span aria-hidden="true">{{ program?.serviceEndDate | formatDate }}</span>
                </span>
              </span>
              <span>
                Authorization Date:
                <span [attr.aria-label]="program?.authorizationDate ? (program?.authorizationDate | date : 'MMMM d, y') : ''">
                  <span aria-hidden="true">{{program?.authorizationDate | formatDate}}</span>
                </span>
              </span>
            </div>
          </div>
          <div class="k-d-flex k-align-items-center k-gap-2">
            <fa-icon icon="location-dot"></fa-icon>
            <span>{{ program?.location || program?.locationOther }}</span>
          </div>
        </kendo-card-body>
        <kendo-card-footer *ngIf="showMandate" class="footer !k-p-0">
          <div *ngIf="!isProgram(program)">
            <div class="mandate-details  k-px-6 k-py-4">
              <div class="mandate-text">Mandate</div>
              <div class="k-font-bold">{{program?.mandateShortDescription}}</div>
              <ng-container *ngIf="!program?.isSplit">
                <div>{{program?.assignmentStatus}} - {{program?.assignmentSubStatus }}</div>
                <ng-container *ngTemplateOutlet="providerDetails; context: { $implicit: program }">
                </ng-container>
              </ng-container>
            </div>
            <div class="split-details  k-px-6 k-py-4"
              *ngFor="let split of program?.splitMandateAssignment; let i = index">
              Split {{i+1}}
              <div class="k-font-bold">{{program?.mandateShortDescription}}</div>
              <div>{{program?.assignmentStatus}} - {{program?.assignmentSubStatus }}</div>
              <ng-container
                *ngTemplateOutlet="providerDetails; context: { $implicit: program?.splitMandateAssignment }">
              </ng-container>
            </div>
          </div>
          <div *ngIf="isProgram(program)" class="mandate-details k-px-6 k-py-4">
            <div class="k-d-flex k-align-items-start k-gap-2">
              <fa-icon icon="calendar"></fa-icon>
              <div>
                <div class="mandate-text">First Attend Date: 
                  <span [attr.aria-label]="program?.firstAttendDate ? (program?.firstAttendDate | date : 'MMMM d, y') : ''">
                    <span aria-hidden="true">{{program?.firstAttendDate | formatDate}}</span> 
                  </span>
                </div>
              </div>
            </div>
          </div>
        </kendo-card-footer>
      </kendo-card>
    </div>
  </div>

  <ng-template #noPrograms>
    <p class="k-p-4">No {{ title }} to show</p>
  </ng-template>
  <ng-template #providerDetails let-data>
    <div class="k-d-flex k-align-items-center k-gap-2">
      <!-- <fa-icon icon="user-nurse"></fa-icon> -->
      <span class="mandate-text">
        {{data?.providerFullName}}
      </span>
    </div>
    <div class="k-d-flex k-align-items-start k-gap-2">
      <fa-icon icon="calendar"></fa-icon>
      <div>
        <div class="mandate-text">Assigned: 
          <span [attr.aria-label]="data?.assignmentStartDate ? (data?.assignmentStartDate | date : 'MMMM d, y') : ''">
            <span aria-hidden="true">{{data?.assignmentStartDate | formatDate}}</span>
          </span>
          - 
          <span [attr.aria-label]="data?.assignmentEndDate ? (data?.assignmentEndDate | date : 'MMMM d, y') : ''">
            <span aria-hidden="true">{{data?.assignmentEndDate | formatDate}}</span>
          </span>
        </div>
        <div class="mandate-text">First Attend Date: 
          <span [attr.aria-label]="data?.firstAttendDate ? (data?.firstAttendDate | date : 'MMMM d, y') : ''">
            <span aria-hidden="true">{{data?.firstAttendDate | formatDate}}</span> 
          </span>
        </div>
        <div class="mandate-text">First Encounter Date: 
          <span [attr.aria-label]="data?.firstEncounterDate ? (data?.firstEncounterDate | date : 'MMMM d, y') : ''">  
            <span aria-hidden="true">{{data?.firstEncounterDate | formatDate}}</span>
          </span>
        </div>
      </div>
    </div>
  </ng-template>

</div>

<kendo-dialog *ngIf="showRfdDialog$ | async" [title]="canEdit ? 'Add Reason for Delay' : 'View Reason for Delay'"
  (close)="rfd.onCloseClick()" [width]="786" [height]="'90vh'" [minWidth]="'1166'" (click)="$event.stopPropagation()">
  <app-reason-for-delay #rfd (close)="displayRfdDialog($event)" (saveEmitter)="onRfdSaved()"
    [studentDetails]="studentProfile" [referralsk]="studentProfile?.referralSK" [studentSk]="studentProfile?.studentSk"
    [nycId]="studentProfile?.nycId" [eiId]="studentProfile?.eiId" [isPreSchool]="studentProfile?.isPreSchool"
    [canEdit]="canEdit">
  </app-reason-for-delay>
  <kendo-dialog-actions>
    <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" *ngIf="canEdit"
      [disabled]="!rfd.hasActiveReasons || rfd.loadSpinner" (click)="rfd.save()">Save</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-capture-first-attend-date-dialog [nycId]="studentIEP?.nycid" [studentIEP]="studentIEP" [isTwelveMonth]="selectedProgram?.isTwelveMonth"
  *ngIf="showCaptureFirstAttendDate$ | async" (closeDialog)="closeCaptureFirstAttendDateDialog()"
  (saved)="onFADSaved()">
</app-capture-first-attend-date-dialog>